export const VERIFIED_ONLY_EMPTY_MESSAGE =
  'No Stripe-verified orders match this period and filters. Turn on "Show unverified transactions" to include pending, unverified, and mismatch rows, or run Stripe validation from Finance reports.'

export function showUnverifiedFromFilters(filters = {}) {
  return filters.showUnverifiedTransactions !== false
}

export function filtersWithShowUnverified(filters = {}, includeUnverified) {
  return {
    ...filters,
    showUnverifiedTransactions: includeUnverified,
  }
}

/**
 * @param {object} [filters]
 * @param {number} rowCount
 * @returns {string|null} message when empty, null when rows exist
 */
export function getCustomReportEmptyMessage(filters, rowCount) {
  if (rowCount > 0) return null
  if (filters?.showUnverifiedTransactions === false) {
    return VERIFIED_ONLY_EMPTY_MESSAGE
  }
  return 'No orders match this period and filters.'
}
